<div class="wz-grid">
  <div class="wz-main">
    <app-recipients-form></app-recipients-form>
  </div>

  <aside class="wz-aside" aria-label="Audience summary">
    <app-recipients-preview></app-recipients-preview>
  </aside>
</div>
